import { useMutation } from "react-query";
import {
  CancelVehicleFlottomatBusinessCaseParams,
  cancelVehicleFlottomatBusinessCase,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const cancelVehicleFlottomatBusinessCaseFn = async (
  params: CancelVehicleFlottomatBusinessCaseParams,
) => {
  return await cancelVehicleFlottomatBusinessCase(params);
};

export function useCancelVehicleFlottomatBusinessCase() {
  return useMutation(cancelVehicleFlottomatBusinessCaseFn, {
    mutationKey: MUTATION_KEYS.cancelVehicleFlottomatBusinessCase,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
